import { createContext, useContext, useEffect } from 'react';
import { setupPresence } from '../services/presenceService';
import { useAuth } from './authProvider';
import { useFirebase } from './firebaseProvider';

import logger from 'utils/logger';
const PresenceContext = createContext({});

/**
 * Provider para gerenciar a presença do usuário autenticado
 */
export const PresenceProvider = ({ children }) => {
  const { user, loading } = useAuth();
  const { myAuth } = useFirebase();

  useEffect(() => {
    // Só configurar presença se houver um usuário autenticado
    if (loading) {
      return;
    }

    if (!user) {
      return;
    }

    // Verificar se há um usuário autenticado no Firebase Auth
    if (!myAuth.currentUser) {
      logger.warn('PresenceProvider: Firebase Auth não tem usuário autenticado');
      return;
    }

    // Usar o UID do Firebase Auth para garantir consistência
    const firebaseUid = myAuth.currentUser.uid;

    // Configurar o sistema de presença para o usuário atual
    const cleanup = setupPresence(firebaseUid);

    // Cleanup ao desmontar ou quando o usuário mudar
    return () => {
      cleanup();
    };
  }, [user, loading, myAuth]);

  return (
    <PresenceContext.Provider value={{}}>
      {children}
    </PresenceContext.Provider>
  );
};

/**
 * Hook para acessar o contexto de presença (se necessário no futuro)
 */
export const usePresence = () => {
  const context = useContext(PresenceContext);
  if (context === undefined) {
    throw new Error('usePresence deve ser usado dentro de um PresenceProvider');
  }
  return context;
};
